<div class="form-row">
  <!-- Orçamento/Pedido -->
  <div class="form-group col-sm-4">
    <label><b>Orçamento/Pedido:</b></label>
    <br />
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="orcamento_pedido" id="optOrcamento" value="0" (change)="pedidoOrcamentoAlterado.emit($event.target.value)" [checked]="pedidoOrcamentoSelecionado == 0" [disabled]="pedidoAprovarExterno" />
      <label class="form-check-label" for="optOrcamento">Orçamento</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="orcamento_pedido" id="optPedido" value="1" (change)="pedidoOrcamentoAlterado.emit($event.target.value)" [checked]="pedidoOrcamentoSelecionado == 1" [disabled]="pedidoAprovarExterno" />
      <label class="form-check-label" for="optPedido">Pedido</label>
    </div>
  </div>
  <!-- Canal de Vendas -->
  <div class="form-group col-sm-4">
    <label><b>Canal de Vendas:</b></label>
    <br />
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="canal_vendas" id="optEmail" value="3" (change)="canalVendaAlterado.emit($event.target.value)" [checked]="canalVendasSelecionado == 3" [disabled]="pedidoAprovarExterno" />
      <label class="form-check-label" for="optEmail">E-mail</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="canal_vendas" id="optTelefone" value="2" (change)="canalVendaAlterado.emit($event.target.value)" [checked]="canalVendasSelecionado == 2" [disabled]="pedidoAprovarExterno" />
      <label class="form-check-label" for="optTelefone">Telefone</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="canal_vendas" id="optWhatsApp" value="4" (change)="canalVendaAlterado.emit($event.target.value)" [checked]="canalVendasSelecionado == 4" [disabled]="pedidoAprovarExterno" />
      <label class="form-check-label" for="optWhatsApp">WhatsApp</label>
    </div>
  </div>
  <!-- Vendedor(a) -->
  <div class="form-group col-sm-4">
    <label><b>Vendedor(a):</b></label>
    <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="vendedorAlterado.emit(vendedor.value)" [disabled]="pedido != null || pedidoAprovarExterno || bloquearAlteracaoVendedor || (!is_master && !is_manager && !is_diretor && configuracao != null && !configuracao.tmk_seleciona_vendedor)">
      @for (opcao of vendedores; track opcao) {
        <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
      }
    </select>
  </div>
</div>
<div class="form-row">
  <!-- Tipo de Pedido -->
  <div class="form-group col-sm-4">
    <label><b>Tipo de Pedido:</b></label>
    <select class="form-control form-control-sm" name="tipo_pedido" #tipo_pedido (change)="tipoPedidoAlterado.emit(tipo_pedido.value)" [disabled]="(configuracao != null && configuracao.tipo_conta_corrente_flex == 2 && produtosAdicionados.length > 0) || pedidoAprovarExterno">
      @for (opcao of tiposPedido; track opcao) {
        <option [value]="opcao.cod_tipopedvenda" [selected]="tiposPedidoSelecionado != null ? opcao.cod_tipopedvenda == tiposPedidoSelecionado.cod_tipopedvenda : null">{{ opcao.descricao }}</option>
      }
    </select>
  </div>
  <!-- Transportadora -->
  @if (configuracao != null && configuracao.seleciona_transportadora) {
    <div class="form-group col-sm-4">
      <label><b>Transportadora:</b></label>
      <select class="form-control form-control-sm" name="transportadora" #transportadora (change)="transportadoraAlterada.emit(transportadora.value)" [disabled]="pedidoAprovarExterno">
        @for (opcao of transportadoras; track opcao) {
          <option [value]="opcao.id_transportadora" [selected]="transportadoraSelecionada != null ? opcao.id_transportadora == transportadoraSelecionada.id_transportadora : null">{{ opcao.nm_transportadora }}</option>
        }
      </select>
    </div>
  }
  @if (configuracao != null && !configuracao.seleciona_transportadora && clienteSelecionado != null && clienteSelecionado.nm_transportadora != null) {
    <div class="form-group col-sm-4">
      <label><b>Transportadora:</b></label>
      <input class="form-control form-control-sm" type="text" name="cliente_transportadora" [value]="clienteSelecionado.nm_transportadora" disabled />
    </div>
  }
  <!-- Frete -->
  <div class="form-group col-sm-4">
    <label><b>Frete:</b></label>
    <select class="form-control form-control-sm" name="frete" #frete (change)="freteAlterado.emit(frete.value)" [disabled]="pedidoAprovarExterno">
      @for (opcao of tiposFrete; track opcao) {
        <option [value]="opcao.id" [selected]="tipoFreteSelecionado != null ? opcao.id == tipoFreteSelecionado.id : null">{{ opcao.descricao }}</option>
      }
    </select>
  </div>
  <!-- Empresa -->
  @if (configuracao != null && configuracao.separar_produtos_por_referencia == 'S') {
    <div class="form-group col-sm-4">
      <label><b>Empresa:</b></label>
      <select class="form-control form-control-sm" name="empresa" (change)="referenciaClienteAlterada.emit($event.target.value)" [disabled]="clienteSelecionado == null || produtosAdicionados.length > 0 || pedidoAprovarExterno">
        @for (opcao of produtosReferenciasCliente; track opcao) {
          <option [value]="opcao.referencia_cliente" [selected]="produtoReferenciaClienteSelecionado == opcao.referencia_cliente">{{ opcao.referencia_cliente }}</option>
        }
      </select>
    </div>
  }
  <!-- Forma de Pagamento -->
  @if (formasPagamento.length > 0) {
    <div class="form-group col-sm-4">
      <label><b>Forma de Pagamento:</b></label>
      <select class="form-control form-control-sm" name="forma_pagamento" #forma_pagamento (change)="formaPagamentoAlterada.emit(forma_pagamento.value)" [disabled]="clienteSelecionado == null || pedidoAprovarExterno">
        @for (opcao of formasPagamento; track opcao) {
          <option [value]="opcao.id" [selected]="formaPagamentoSelecionada != null ? opcao.id == formaPagamentoSelecionada.id : null">{{ opcao.descricao }}</option>
        }
      </select>
    </div>
  }
  <!-- Dt. Validade -->
  <div class="form-group col-sm-4">
    <label><b>Dt. Validade:</b></label>
    <input class="form-control form-control-sm" type="text" name="dt_validade" ngbDatepicker #dt_validade="ngbDatepicker" (click)="dt_validade.toggle()" [ngModel]="dataValidade" (ngModelChange)="dataValidadeAlterada.emit($event)" [ngClass]="{ 'is-invalid': dataValidadeInvalida }" [disabled]="(configuracao != null && configuracao.pedido_dt_validade_automatica != null) || pedidoAprovarExterno" />
    @if (dataValidadeInvalida) {
      <div class="erro pt-1">Dt. Validade inválida!</div>
    }
  </div>
  <!-- Pedido Programado -->
  <div class="form-group col-sm-4">
    <label><b>Pedido Programado:</b></label>
    <input class="form-control form-control-sm" type="text" name="dt_previsao_entrega" ngbDatepicker #dt_previsao_entrega="ngbDatepicker" (click)="dt_previsao_entrega.toggle()" [ngModel]="dataPrevisaoEntrega" (ngModelChange)="dataPrevisaoEntregaAlterada.emit($event)" [disabled]="pedidoAprovarExterno" />
  </div>
  <!-- Local de Entrega -->
  @if (configuracao != null && configuracao.exibe_local_entrega) {
    <div class="form-group col-sm-4">
      <label><b>Local de Entrega:</b></label>
      <select class="form-control form-control-sm" name="local_entrega" #local_entrega (change)="localEntregaAlterado.emit(local_entrega.value)" [disabled]="clienteSelecionado == null || pedidoAprovarExterno">
        <option value="0" [selected]="clienteLocalEntregaSelecionado == null"></option>
        @for (opcao of clienteLocaisEntrega; track opcao) {
          <option [value]="opcao.id" [selected]="clienteLocalEntregaSelecionado != null ? opcao.id == clienteLocalEntregaSelecionado.id : null">{{ opcao.localentrega }}</option>
        }
      </select>
    </div>
  }
</div>
